/**
 *  管理员管理相关接口
 */
import { axios } from '@/utils/request'

// 分页查询角色列表数据
export function queryAdminerPage (parameter) {
  return axios({
    url: '/sys/adminer/query',
    method: 'get',
    params: { ...parameter, 'page.curPage': parameter.curPage, 'page.pageSize': parameter.pageSize }
  })
}

// 查询单个管理员详情
export function getAdminerDetail (id) {
  return axios({
    url: `/sys/adminer/${id}`,
    method: 'get'
  })
}

// 获取当前登录管理员详情
export function getMyInfo () {
  return axios({
    url: `/sys/adminer/myInfo`,
    method: 'get'
  })
}

// 当前用户修改个人资料
export function putMyProfile (parameter) {
  return axios({
    url: `/sys/adminer/putMyProfile`,
    method: 'patch',
    data: parameter
  })
}

// 添加角色信息
export function addAdminer (parameter) {
  return axios({
    url: '/sys/adminer',
    method: 'post',
    data: parameter
  })
}

// 修改角色信息
export function updateAdminer (id, parameter) {
  return axios({
    url: `/sys/adminer/${id}`,
    method: 'put',
    data: parameter
  })
}

// 删除
export function deleteAdminer (parameter) {
  return axios({
    url: `/sys/adminer`,
    method: 'delete',
    params: parameter
  })
}

// 修改启用状态
export function changeEnabled (id, parameter) {
  return axios({
    url: `/sys/adminer/${id}/changeEnabled`,
    method: 'patch',
    data: parameter
  })
}

// 修改密码
export function changeMyPassword (parameter) {
  return axios({
    url: `/sys/adminer/changeMyPassword`,
    method: 'patch',
    data: parameter
  })
}
